<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">PWmat</div>
      </div>

      <img class="pwmat-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-introduce-container">

     <div class="pwmat-introduce-content">
       <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">{{ $t("allinone.title") }}</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text2">{{ $t("allinone.info") }}
         </p>
       </div>

       <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">{{ $t("allinone.qstationT") }} QStation</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text2">{{ $t("allinone.qstationInfo") }}
         </p>
       </div>

       <div class="mstation-introduce-content-info">
        <p class="mstation-introduce-content-info-text">{{ $t("allinone.qstationT2") }}</p>
        <table v-if="this.$i18n.locale === 'zh'" class="mstation-introduce-table">
          <tr class="mstation-introduce-th">
             <th colspan="2" style="text-align: center;" class="mstation-introduce-text-th">型号：AW7145-2GTc</th>
           </tr>
           <tr class="mstation-introduce-th">
             <th class="mstation-introduce-text-th">硬件配置</th>
             <th class="mstation-introduce-text-th">软件配置</th>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">外观：塔式服务器</td>
             <td class="mstation-introduce-text-td">预装PWmat基于平面波密度泛函理论CPU计算软件V1.0</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">CPU：1颗AMD EPYC 9654/主频2.4G/睿频3.55G/96核/192线程/384MB/360W</td>
             <td class="mstation-introduce-text-td">集成多功能一体化智能建模与一键式物理性质计算的可视化操作界面</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">内存：8块64G 4800MHz DDR5 ECC REGS</td>
             <td class="mstation-introduce-text-td">预装PWmat软件开发的前后处理工具PWkit</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">系统盘：1块480G/SATA-3/2.5寸/企业级</td>
             <td class="mstation-introduce-text-td">预装龙讯开发的机器学习力场软件包MatPL</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">数据盘：1块8T HDD 企业级</td>
             <td class="mstation-introduce-text-td">可预装用户需要的开源免费的理论计算软件，或用户已经获得版权的收费软件</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">电源：1500W电源</td>
             <td class="mstation-introduce-text-td">作业调度软件slurm</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">网络：双口千兆</td>
             <td class="mstation-introduce-text-td"></td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">系统：预装 centos 7.9</td>
             <td class="mstation-introduce-text-td"></td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">3年产品质保</td>
             <td class="mstation-introduce-text-td"></td>
           </tr>
        </table>
        <table v-else class="mstation-introduce-table">
          <tr class="mstation-introduce-th">
             <th colspan="2" style="text-align: center;" class="mstation-introduce-text-th">Model: AW7145-2GTc</th>
           </tr>
           <tr class="mstation-introduce-th">
             <th class="mstation-introduce-text-th">Hardware Configuration</th>
             <th class="mstation-introduce-text-th">Software Configuration</th>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">Appearance: Tower server</td>
             <td class="mstation-introduce-text-td">Pre-installed PWmat CPU calculation software V1.0 based on plane wave density functional theory</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">CPU: 1 AMD EPYC 9654/main frequency 2.4G/turbo frequency 3.55G/96 cores/192 threads/384MB/360W</td>
             <td class="mstation-introduce-text-td">Integrated multi-functional integrated intelligent modeling and one-click physical property calculation visual operation interface</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">Memory: 8 x 64G 4800MHz DDR5 ECC REGS</td>
             <td class="mstation-introduce-text-td">Pre-installed PWmat software development pre- and post-processing tool PWkit</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">OS disk: 1 480G/SATA-3/2.5-inch/enterprise level</td>
             <td class="mstation-introduce-text-td">Pre-installed machine learning force field software package MatPL developed by Longxun</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">Data disk: 1 8T HDD enterprise level</td>
             <td class="mstation-introduce-text-td">Can pre-install open source free theoretical calculation software required by users, or paid software that users have obtained copyrights</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">Power supply: 1500W power supply</td>
             <td class="mstation-introduce-text-td">Job scheduling software: slurm</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">Network: Dual-port Gigabit</td>
             <td class="mstation-introduce-text-td"></td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">OS: Pre-installed centos 7.9</td>
             <td class="mstation-introduce-text-td"></td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">3-year product warranty</td>
             <td class="mstation-introduce-text-td"></td>
           </tr>
        </table>
      </div>

       <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">{{ $t("allinone.mstationT") }} Mstation</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text2">{{ $t("allinone.mstationInfo") }}
         </p>

       <div class="mstation-introduce-content-img">
         <img class="mstation-introduce-content-left-img-png" src="../../assets/produce/mstation/mstation-product.jpg">
         <img class="mstation-introduce-content-right-img-png" src="../../assets/home/product_3.png">
       </div>


       <div class="mstation-introduce-content-info">
         <p class="mstation-introduce-content-info-text">{{ $t("allinone.mstationT2") }}</p>

         <table class="mstation-introduce-table">
           <tr class="mstation-introduce-th">
             <th class="mstation-introduce-text-th">{{ $t("allinone.mstationT2R0C1") }}</th>
             <th class="mstation-introduce-text-th">{{ $t("allinone.mstationT2R0C2") }}</th>
             <th class="mstation-introduce-text-th">{{ $t("allinone.mstationT2R0C3") }}</th>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">CPU</td>
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R1C2") }}</td>
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R1C3") }}</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">GPU</td>
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R2C2") }}</td>
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R2C3") }}</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R3C1") }}</td>
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R3C2") }}</td>
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R3C3") }}</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R4C1") }}</td>
             <td class="mstation-introduce-text-td">CentOS 7.9</td>
             <td class="mstation-introduce-text-td">CentOS 7.9</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R5C1") }}</td>
             <td class="mstation-introduce-text-td"></td>
             <td class="mstation-introduce-text-td">{{ $t("allinone.mstationT2R5C3") }}</td>
           </tr>
         </table>
       </div>
       </div>

       <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">{{ $t("allinone.mcluster") }}</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text2">{{ $t("allinone.mclusterP1") }}</p>

       <div class="mcluster-introduce-content-img">
         <img class="mcluster-introduce-content-img-png" style="margin-top: 0;vertical-align: top;display: inline-block;margin-right: 50px" src="../../assets/produce/mcluster/mcluster_product.jpg">
       </div>

         <p class="pwmat-introduce-content-info-text2">{{ $t("allinone.mclusterP2") }}</p>

         <div class="mcluster-introduce-content-info">
         <table class="mcluster-introduce-table">
           <tr class="mcluster-introduce-th">
             <th class="mcluster-introduce-text-th">{{ $t("allinone.mcloudR0C1") }}</th>
             <th class="mcluster-introduce-text-th">{{ $t("allinone.mcloudR0C2") }}</th>
             <th class="mcluster-introduce-text-th">{{ $t("allinone.mcloudR0C3") }}</th>
             <th class="mcluster-introduce-text-th">{{ $t("allinone.mcloudR0C4") }}</th>
             <th class="mcluster-introduce-text-th">{{ $t("allinone.mcloudR0C5") }}</th>
             <th class="mcluster-introduce-text-th">{{ $t("allinone.mcloudR0C6") }}</th>
           </tr>
           <tr class="mcluster-introduce-td" v-for="param in mclustertParams" :key="param">
             <td class="mcluster-introduce-text-td">{{param.testSystem}}</td>
             <td class="mcluster-introduce-text-td">{{param.atomicNum}}</td>
             <td class="mcluster-introduce-text-td">{{param.electronicNum}}</td>
             <td class="mcluster-introduce-text-td">{{param.truncationCan}}</td>
             <td class="mcluster-introduce-text-td">{{param.turns}}</td>
             <td class="mcluster-introduce-text-td">{{param.time}}</td>
           </tr>
         </table>
       </div>
       </div>

     </div>

     <div class="pwmat-introduce-content-title">
         <div class="pwmat-introduce-content-title-text">{{ $t("allinone.mcloud") }}</div>
         <div class="pwamt-introduce-line"></div>
       </div>
       <div class="pwmat-introduce-content-info">
         <p class="pwmat-introduce-content-info-text2">{{ $t("allinone.mcloudP1") }}<a href="https://mcloud.lonxun.com" target="_blank">https://mcloud.lonxun.com</a>
         </p>
       </div>


     </div>
    </div>
</template>

<script>
  import {PWMAT_RESOURCE} from '../../helpers/consts'
  export default {
    name: "companyIntroduce",
    data() {
      return {
        PWMAT_RESOURCE,
      }
    },
    methods:{
      toMSTATIONDownload(){
        this.$router.push({ name: 'MSTATIONDownload'})
      },
      toPotentialDownload(){
        this.$router.push({ name: 'PotentialDownload'})
      },
      toModuleDownload(){
        this.$router.push({ name: 'ModuleDownload'})
      },
      toQuikStart(){
        this.$router.push({ name: 'QuickStartTutorial'})
      },
      toTutorials(){
        this.$router.push({ name: 'Tutorials'})
      },
      toCase(){
        this.$router.push({ name: 'Case'})
      },
      toTrain(){
        this.$router.push({ name: 'Train'})
      },
      toManual(){
        window.open(this.PWMAT_RESOURCE+'Manual.pdf')
      },
      tocnManual(){
        window.open(this.PWMAT_RESOURCE+'Manual_cn.pdf')
      },
      toProchureBook(){
        window.open(this.PWMAT_RESOURCE+'prochure.pdf')
      },
      toProchureNewFunctions(){
        window.open(this.PWMAT_RESOURCE+'PWmat_2019_new_functions.pdf')
      }

    }
  }
</script>

<script>
  import {MCLUSTERTable} from '../../helpers/productParam'
  export default {
    name: "companyIntroduce",
    data() {
      return {
        mclustertParams:''
      }
    },
    created(){
      this.mclustertParams = MCLUSTERTable
    },
  }
</script>

<style scoped>
  .pwmat-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .pwmat-introduce-background{
    margin-top: 70px;
  }
  .pwmat-introduce-banner{
    overflow:hidden;
  }
  .pwmat-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .pwmat-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .pwmat-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .pwmat-introduce-content-title{
    padding-top: 50px;
  }
  .pwmat-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .pwmat-introduce-content-info{
    margin-top: 30px;
    text-align: justify;
  }
  .pwmat-introduce-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .pwmat-introduce-content-info-text2{
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:30px;
  }
  .pwamt-introduce-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .pwmat-introduce-function{
    display: inline-block;
    padding-left: 80px;
    margin-bottom: 50px;
    width: 346px;
  }
  .pwmat-introduce-function-img{
    display: inline-block;
    vertical-align: top;
  }
  .pwmat-introduce-function-text{
    display: inline-block;
    vertical-align: top;
    margin-left: 23px;
  }
  .pwmat-introduce-function-name{
    font-size:18px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 8px;
    margin-top: -6px;
  }
  .pwmat-introduce-function-desc{
    font-size:14px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:20px;
  }
  .pwmat-inroduce-application{
    background:rgba(73,145,201,0.1);
    padding: 24px 99px 27px 99px;
    margin-bottom: 50px;
  }
  .pwmat-inroduce-application-group-1{
    width:539px;
    display: inline-block;
  }
  .pwmat-inroduce-application-group-2{
    width:299px;
    display: inline-block;
  }
  .pwmat-inroduce-application-text{
    font-size:16px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(79,76,77,1);
    line-height:38px;
    margin-bottom: 0;
  }
  .mstation-introduce-content-img{
    text-align: center;
  }
  .mstation-introduce-content-left-img-png{
    margin-top: 50px;
    margin-right: 180px;
    width: 300px;
  }
  .mstation-introduce-content-right-img-png{
    margin-top: 50px;
    width: 400px;
  }
  .mstation-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .mstation-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .mstation-introduce-td{
    height: 45px;
  }
  .mstation-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .mstation-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:17px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:17px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-content-info{
    margin-top: 40px;
  }
  .mstation-introduce-content-info-text{
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .mcluster-introduce-content-img{
    text-align: center;
  }
  .mcluster-introduce-content-img-png{
    margin-top: 50px;
    width: 300px;
  }
  .mcluster-introduce-content-info{
    margin-top: 40px;
  }
  .mcluster-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .mcluster-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .mcluster-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .mcluster-introduce-td{
    height: 45px;
  }
  .mcluster-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding-left: 16px;
  }
  @media screen and (max-width:482px) {
    .pwmat-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .pwmat-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .pwmat-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .pwmat-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .pwmat-introduce-container{
      max-width: 1068px;
    }
  }

</style>
